module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/2-5f78806898243b006f882c4788d83181.svg";